export const BaseApiUrl = process.env.REACT_APP_BASE_URL
export const BaseSocketUrl = process.env.REACT_APP_BASE_SOCKET_URL